import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take, finalize } from 'rxjs/operators';

import { AppService } from '../../../shared/services/app.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-auth-sso-form-page',
  templateUrl: './auth-sso-form-page.component.html',
  styleUrls: ['./auth-sso-form-page.component.sass']
})
export class AuthSsoFormPageComponent implements OnInit {
  public model = {
    email: ''
  };
  public loading: boolean;
  public error: any;

  constructor(
    private appService: AppService,
    private authService: AuthService,
  ) {
    this.appService.setTitle('auth.login.heading');
  }

  ngOnInit() {}

  onFormSubmitted(formComponent: any) {
    this.error = false;

    const { email } = formComponent.model;

    this.authService.loginSso(email).pipe(take(1)).subscribe(
      (response: any) => {
        document.location = response['redirect'];
      },
      (error) => {
        this.error = error;
      }
    );
  }
}
